import { render, staticRenderFns } from "./PlaygroundView.vue?vue&type=template&id=b138ff36&"
import script from "./PlaygroundView.vue?vue&type=script&lang=js&"
export * from "./PlaygroundView.vue?vue&type=script&lang=js&"
import style0 from "./PlaygroundView.vue?vue&type=style&index=0&id=b138ff36&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports